<template>
    <FreelancerSignupStep data-testid="welcome-to-malt--strategy" :save-step="handleSaveStep" title-color="neutral">
        <template #freelancer-signup-step-title>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="$t('profile.signup.step.welcome.strategy.title')"></div>
        </template>
        <template #freelancer-signup-step-subtitle>{{ $t('profile.signup.step.welcome.strategy.subtitle') }}</template>
        <template #freelancer-signup-step-main-left>
            <FreelancerSignupArticles>
                <!-- TOOD i18n -->
                <FreelancerSignupArticle data-testid="welcome-to-malt-strategy-article-1">
                    <template #article-icon><IconCounter :counter="1" /></template>
                    <template #article-title>{{ $t('profile.signup.step.welcome.strategy.paragraph.1.title') }}</template>
                    <template #article-content>
                        {{ $t('profile.signup.step.welcome.strategy.paragraph.1.content') }}
                    </template>
                </FreelancerSignupArticle>
                <!-- TOOD i18n -->
                <FreelancerSignupArticle data-testid="welcome-to-malt-strategy-article-2">
                    <template #article-icon>
                        <IconCounter :counter="2" />
                    </template>
                    <template #article-title>{{ $t('profile.signup.step.welcome.strategy.paragraph.2.title') }}</template>
                    <template #article-content>
                        {{ $t('profile.signup.step.welcome.strategy.paragraph.2.content') }}
                    </template>
                </FreelancerSignupArticle>
                <!-- TOOD i18n -->
                <FreelancerSignupArticle data-testid="welcome-to-malt-strategy-article-3">
                    <template #article-icon><IconCounter :counter="3" /></template>
                    <template #article-title>{{ $t('profile.signup.step.welcome.strategy.paragraph.3.title') }}</template>
                    <template #article-content>
                        {{ $t('profile.signup.step.welcome.strategy.paragraph.3.content') }}
                    </template>
                </FreelancerSignupArticle>
            </FreelancerSignupArticles>
        </template>
        <template #freelancer-signup-step-main-right>
            <div class="welcome-strategy-illustration">
                <MaltImg
                    :src="getBrandIllustration('malt-strategy-vettedprofiles-large.svg')"
                    width="181"
                    height="263"
                    alt="Welcome to Malt Strategy"
                />
            </div>
        </template>
    </FreelancerSignupStep>
</template>
<script setup lang="ts">
    import {MaltImg} from '#components';
    import {definePageMeta, useLogger, useTranslation} from '#imports';
    import {getBrandIllustration} from '@malt/asset-utils';
    import FreelancerSignupArticle from '~/components/ui/FreelancerSignupArticle.vue';
    import FreelancerSignupArticles from '~/components/ui/FreelancerSignupArticles.vue';
    import IconCounter from '~/components/ui/IconCounter.vue';
    import {FreelancerSignupContext} from '~/features/freelancer-signup/_common/types/FreelancerSignupContext';
    import {useGetInvitationCode} from '~/features/freelancer-signup/invitation-code/composables/useGetInvitationCode';
    import {FreelancerSignupStepName} from '~/features/freelancer-signup/navigation/types/FreelancerSignupStep';
    import FreelancerSignupStep from '~/features/freelancer-signup/steps/ui/FreelancerSignupStep.vue';
    import {useFreelancerSignupStore} from '~/features/freelancer-signup/workflow/store/useFreelancerSignupStore';

    definePageMeta({
        funnelStepName: FreelancerSignupStepName.WELCOME_TO_MALT_STRATEGY,
        funnelContext: FreelancerSignupContext.STRATEGY,
    });

    // Stores
    const freelancerSignupStore = useFreelancerSignupStore();

    // Handlers
    async function handleSaveStep(): Promise<boolean> {
        const {getInvitationCode} = useGetInvitationCode();
        await freelancerSignupStore.initWorkflowIfNeeded({context: FreelancerSignupContext.STRATEGY, invitationCode: getInvitationCode()});

        return true;
    }
</script>

<style scoped lang="scss">
    .welcome-strategy-illustration {
        box-sizing: border-box;
        width: 225px;
        height: 264px;
        padding: 0 44px 1px 0;
    }
</style>
